module.exports = __webpack_public_path__ + "img/14.ca9fb66b.png";